import type { PageLayoutField } from '@atlassian/jira-entry-point-page-layout-fields/src/index.tsx';
import type {
	AnyEntryPoint,
	ReferenceFromEntryPoint,
} from '@atlassian/jira-entry-point/src/common/types.tsx';
import { useRouteEntryPoint } from '@atlassian/jira-entry-points-plugin/src/services/use-entry-point/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';

export const usePageLayoutEntryPoint = <TEntryPoint extends AnyEntryPoint>(
	layoutField: PageLayoutField,
) => {
	const route = useCurrentRoute();
	const entryPointReference = useRouteEntryPoint({ route });

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return entryPointReference?.entryPoints[layoutField] as ReferenceFromEntryPoint<TEntryPoint>;
};
